import {ContentBlock, Icon} from "@gplibraries/react/components";

interface PrimaryContactProps {
  name: string;
  email: string;
}

export default function PrimaryDealerContactBlock({ name, email }: PrimaryContactProps) {

  return (
    <ContentBlock title={'Your Dealer Admin'} icon={<Icon glyph={'building-fill-lock'}/>}>
      <div className={'tm-info-block flex-col'}>

        <h3>{name}</h3>

        <div className="flex-inline">
          <Icon glyph={'envelope-at-fill'}/>
          {email.toLowerCase()}
        </div>

        <em className={'primary-contact-message'}>To update, please contact the Credit department at 1-800-472-0166.</em>

      </div>
    </ContentBlock>
  );
}